<template>
  <v-form ref="form">
    <v-layout row wrap>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="NTTLeadOpco"
            :items="LeadOpco_values"
            label="NTT Lead Opco"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-menu
            ref="menu"
            v-model="menuDateAdded"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
                v-model="dateAdded"
                label="Date Added (month)"
                readonly
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateAdded"
              type="month"
              scrollable
          >
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menuDateAdded = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="saveDateAdded">OK</v-btn> <!-- Qui cambiato -->
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-textarea
            v-model="notesComments"
            auto-grow
            box
            :counter="1000"
            :rules="rules.notesComments"
            name="notesComments"
            label="Notes/Comments"
            border-radius="20px"
            value=""
            rows="2"
            @blur="sanitize($event,'notesComments')"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="stateOfContact"
            :items="stateOfContacts"
            label="State of contact"
            :error-messages="stateOfContactErrors"
            @change="$v.stateOfContact.$touch()"
            @blur="$v.stateOfContact.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="market"
            :items="Object.values(marketArray)"
            label="Addressed Market"
            multiple
            chips
            deletable-chips
            :menu-props="{ offsetY: true }"
            @change="$v.market.$touch()"
            @blur="$v.market.$touch()"
        >


          <template v-slot:prepend-item>
            <v-list-tile v-if="marketArray !== undefined && startupId !== '' && userInfo.role==='APPROVER_INNOVATION'"
                ripple
                @click="enableNewMarket = true"
            >
              <v-list-tile-action>
                <v-icon>mdi-plus</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Add new Market</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="marketArray !== undefined && startupId !== '' && userInfo.role==='APPROVER_INNOVATION'"
                class="mt-2"></v-divider>
            <v-list-tile
                ripple
                @click="selectAllMarket"
            >
              <v-list-tile-action>
                <v-checkbox v-model="selectedAllMarkets"
                >
                </v-checkbox>
              </v-list-tile-action>
              <v-list-tile-content>
                  <template v-if="selectedAllMarkets">
                    Deselect all
                  </template>
                  <template v-else>
                    Select all
                  </template>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="marketArray !== undefined && startupId !== '' && userInfo.role==='APPROVER_INNOVATION'"
                       class="mt-2"></v-divider>
          </template>

          <template v-slot:item="{ item, on, attrs }">
            <v-list-tile avatar>
              <v-list-tile-action>
            <v-checkbox v-bind="attrs"
                        v-model="market.includes(item)"
            >
            </v-checkbox>
              </v-list-tile-action>
              <v-list-tile-content>
              {{ item }}
              </v-list-tile-content>
            </v-list-tile>
            <v-spacer></v-spacer>
            <v-icon v-if="startupId !== '' && userInfo.role==='APPROVER_INNOVATION'"
                    color="red"
                    @click.stop="openDeleteMarket(item)">mdi-delete
            </v-icon>
          </template>
        </v-select>

        <v-dialog
            v-model="dialogDeleteConfirmMarket"
            max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Deletion market confirmation</span>
            </v-card-title>

            <v-card-text>
              <v-flex>
                <span class="subheading">Are you sure you want to delete this market '{{ marketToDelete }}'?</span>
              </v-flex>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>
              <v-btn
                  round
                  color="red"
                  flat
                  @click="dialogDeleteConfirmMarket=false"
              >
                NO
              </v-btn>
              <v-btn
                  round
                  color="green"
                  flat
                  @click="deleteMarket"
              >
                YES
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="enableNewMarket"
            max-width="650"
            persistent
        >
          <v-card>
            <v-card-title class="headline" style="word-break: break-word">
              Add new market
            </v-card-title>

            <v-card-text>
              Which market do wou want to add?
              <v-text-field
                  v-model="newMarket"
                  regular

                  autofocus
                  color="deep-purple"
                  label="New Market"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                  round
                  color="green"
                  flat
                  @click="addMarket()"
              >
                Confirm
              </v-btn>
              <v-btn
                  round
                  color="red"
                  flat
                  @click="closeNewMarket"
              >
                close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="techArea"
            :items="techAreas"
            :error-messages="techAreaErrors"
            label="Technology Area"
            @change="$v.techArea.$touch()"
            @blur="$v.techArea.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="replicationComplexity"
            :items="replicationComplexities"
            :error-messages="replicationErrors"
            label="Replication Complexity"
            @change="$v.replicationComplexity.$touch()"
            @blur="$v.replicationComplexity.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="deploymentComplexity"
            :items="deploymentComplexities"
            label="Deployment Complexity"
            :error-messages="deploymentErrors"
            @change="$v.deploymentComplexity.$touch()"
            @blur="$v.deploymentComplexity.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="technologicalFootprint"
            :items="technologicalFootprints"
            label="Technological Footprint"
            :error-messages="footprintErrors"
            @change="$v.technologicalFootprint.$touch()"
            @blur="$v.technologicalFootprint.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="businessEnabler"
            :items="businessEnablers"
            :error-messages="businessErrors"
            label="Extensive Business Enabler"
            @change="$v.businessEnabler.$touch()"
            @blur="$v.businessEnabler.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="fundingStatus"
            :items="fundingStatusArray"
            :error-messages="fundingErrors"
            label="Funding Status"
            @change="$v.fundingStatus.$touch()"
            @blur="$v.fundingStatus.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="financialStatus"
            :items="financialStatusArray"
            :error-messages="financialErrors"
            label="Financial Status"
            @change="$v.financialStatus.$touch()"
            @blur="$v.financialStatus.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-text-field
            v-model="bslContact"
            label="NTT DATA SPOC"
            @input="$v.bslContact.$touch()"
            :counter="200"
            :rules="rules.bslContact"
            @blur="sanitize($event,'bslContact')"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3" >
        <v-textarea
            v-model="opportunities"
            auto-grow
            box
            :counter="1000"
            :rules="rules.opportunities"
            name="opportunities"
            label="Opportunities"
            border-radius="20px"
            value=""
            rows="2"
            @blur="sanitize($event,'opportunities')"

        />
      </v-flex>

      <v-flex xs12 sm6 md4 class="pa-3">
        <v-textarea
            v-model="projectState"
            auto-grow
            box
            name="projectState"
            label="Project State (if any)"
            border-radius="20px"
            value=""
            rows="2"
            @blur="sanitize($event,'projectState')"
            :counter="1000"
            :rules="rules.projectState"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="battlecard"
            :items="battlecards"
            :error-messages="battlecardErrors"
            label="Battlecard available"
            @change="$v.battlecard.$touch()"
            @blur="$v.battlecard.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="agreement"
            :items="agreements"
            :error-messages="agreementErrors"
            label="Agreement"
            @change="$v.agreement.$touch()"
            @blur="$v.agreement.$touch()"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
                v-model="date"
                label="Evaluation date (month)"
                readonly
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="date"
              type="month"
              scrollable
          >
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-text-field
            v-model="linkPeers"
            label="Link to folder in Peers"
            :rules="rules.linkPeers"
            :counter="500"
            @input="$v.linkPeers.$touch()"
            @blur="sanitize($event,'linkPeers')"
        />
      </v-flex>
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="opCo"
            :items="Object.values(opCoArray)"
            :error-messages="opcoErrors"
            label="OpCo"
            @change="$v.opCo.$touch()"
            @blur="$v.opCo.$touch()"
        >
          <template v-slot:prepend-item>
            <v-list-tile
                v-if="opCoArray !== undefined && startupId !== '' && userInfo.role==='APPROVER_INNOVATION'"
                ripple
                @click="enableNewOpco = true"
            >
              <v-list-tile-action>
                <v-icon>mdi-plus</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Add new OpCo</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="opCoArray !== undefined && startupId !== '' && userInfo.role==='APPROVER_INNOVATION'"
                       class="mt-2"></v-divider>
          </template>

          <template slot="item" slot-scope="data">
            {{ data.item }}
            <v-spacer></v-spacer>
            <v-icon v-if="startupId !== '' && userInfo.role==='APPROVER_INNOVATION'" color="red"
                    @click.stop="openDeleteOpco(data.item)">mdi-delete
            </v-icon>
          </template>
        </v-select>
        <v-dialog
            v-model="dialogDeleteConfirm"
            max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Deletion opco confirmation</span>
            </v-card-title>

            <v-card-text>
              <v-flex>
                <span class="subheading">Are you sure you want to delete this opco '{{ opcoToDelete }}'?</span>
              </v-flex>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>
              <v-btn
                  round
                  color="red"
                  flat
                  @click="dialogDeleteConfirm=false"
              >
                NO
              </v-btn>
              <v-btn
                  round
                  color="green"
                  flat
                  @click="deleteOpco"
              >
                YES
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="enableNewOpco"
            max-width="650"
            persistent
        >
          <v-card>
            <v-card-title class="headline" style="word-break: break-word">
              Add new opco {{ opCo }}
            </v-card-title>

            <v-card-text>
              Which opco do wou want to add?
              <v-text-field
                  v-model="newOpco"
                  regular

                  autofocus
                  color="deep-purple"
                  label="New Opco"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                  round
                  color="green"
                  flat
                  @click="addOpco()"
              >
                Confirm
              </v-btn>
              <v-btn
                  round
                  color="red"
                  flat
                  @click="closeNewOpco"
              >
                close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>

      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="sustainabilityGoals"
            :items="sustainabilityGoalsItems"
            label="Sustainability Goals"
            multiple
            chips
            :rules="rules.sustainabilityGoals"
        >
        </v-select>
      </v-flex>


      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="NTT_E_G_M"
            :items="NTT_E_G_M_values"
            :error-messages="NTT_E_G_M_Errors"
            label="NTT E/G/M Themes"
            @change="$v.NTT_E_G_M && $v.NTT_E_G_M.$touch()"
            @blur="$v.NTT_E_G_M && $v.NTT_E_G_M.$touch()"
        />
      </v-flex>
<!-- @change="updateTechTrend" -->
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-text-field
          label="Technological Trend"
          v-model="TechTrend"
          readonly
        >
          <template v-if="NTT_E_G_M" v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon @click="showTechGraphic=true" v-on="on">mdi-chart-line</v-icon>
                </template>
                Click here to visualise the graphic
              </v-tooltip>
          </template>

        </v-text-field>
        <v-dialog v-model="showTechGraphic" max-width="800px">
          <v-card>
            <v-card-title class="headline">Tech Graphic</v-card-title>
            <v-card-text>
              <TechGraphic ref="techGraphic" :techTrendData="techTrendData" />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="showTechGraphic=false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>

<!--      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="RegionZone"
            :items="RegionZone_values"
            :error-messages="RegionZone_Errors"
            label="Regions Served"
            multiple
            chips
            deletable-chips
        />
      </v-flex>-->
      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="RegionZone"
            :items="RegionZone_values"
            label="Regions Served"
        />
      </v-flex>

      <!-- <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="RegionZone"
            :items="RegionZone_values"
            :error-messages="RegionZone_Errors"
            label="Regions Served"
            multiple
            chips
            deletable-chips
        />
      </v-flex> -->

      <!-- <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="RegionZone"
            :items="RegionZone_values"
            :error-messages="RegionZone_Errors"
            label="Regions Served"
            multiple
            chips
            deletable-chips
            @change="$v.RegionZone && $v.RegionZone.$touch()"
            @blur="$v.RegionZone && $v.RegionZone.$touch()"
        />
      </v-flex> -->

      <v-flex xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="Source"
            :items="Source_values"
            :error-messages="Source_Errors"
            label="Source"
            @change="$v.Source && $v.Source.$touch()"
            @blur="$v.Source && $v.Source.$touch()"
        />
      </v-flex>

<!--      <v-flex v-if="userInfo.role === 'ADMIN' || userInfo.role === 'APPROVER_INNOVATION'" xs12 sm6 md4 class="pa-3">
        <v-select
            v-model="selectedTrend"
            :items="loadedTrends"
            label="Select trend"
        ></v-select>
      </v-flex>-->

      <v-flex xs12 sm6 md4 class="pa-3">
        <v-text-field
            v-model="token"
            label="Token"
            readonly
        />
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import {validationMixin,} from "vuelidate";
import UrlsService from "@/helpers/UrlsService";
import TimeService from "@/helpers/TimeService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import {required} from "vuelidate/lib/validators";
import Vue from "vue";
import VueSanitize from "vue-sanitize";
import {mapGetters} from "vuex";
import {values} from "@/utils/values.js";
import TechGraphic from "@/pages/Admin/Innovation/StartupManagement/TechGraphic.vue";

Vue.use(VueSanitize);

const nanoid = require('nanoid')

export default {
  name: "FormStartupRegistrationAdmin",
  components: {
    TechGraphic
  },
  mixins: [validationMixin,],
  props: ["startupId"],
  validations: {
    stateOfContact: {required},
    market: {required},
    techArea: {required},
    replicationComplexity: {required},
    deploymentComplexity: {required},
    technologicalFootprint: {required},
    businessEnabler: {required},
    fundingStatus: {required},
    financialStatus: {required},
    opportunities: {required},
    bslContact: {required},
    projectState: {required},
    linkPeers: {required},
    agreement: {required},
    battlecard: {required},
    opCo: {required},
    sustainabilityGoals: {required},
    Task_Resource : {required}
  },
  data: () => ({
    rules: {
      required: value => !!value || 'Required',
      opportunities: [v => v.length <= 1000 || 'Opportunities must be less than 1000 characters'],
      projectState: [v => v.length <= 1000 || 'Project state must be less than 1000 characters'],
      linkPeers: [v => v.length <= 500 || 'Link Peers must be less than 500 characters', value => {
        const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/gm
        return value === '' || value === '-' || pattern.test(value) || 'Invalid link Peers'
      }],
      bslContact: [v => v.length <= 500 || 'BSL contact must be less than 500 characters', value => {
        const pattern = /[^\w.,;'\/àèéìòù -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      sustainabilityGoals: [value => {
        const pattern = /[^\w.,;'\/àèéìòù -]+/gm
        return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'
      }],
      notesComments: [v => v.length <= 1000 || 'Notes/Comments must be less than 1000 characters'],
    },
    token: "",
    loadedTrends: [],
    //selectedTrend: "",
    stateOfContact: "",
    stateOfContacts: values.stateOfContacts,
    techArea: "",
    NTT_E_G_M: "",
    RegionZone : "",
    TechTrend : "",
    showTechGraphic: false,
    techTrendData: [],
    Source : "",
    techAreas: values.techAreas,
    NTT_E_G_M_values: [],
    RegionZone_values : values.RegionZone_values,
    Source_values: values.Source_values,
    replicationComplexity: "",
    replicationComplexities: ["High", "Low", "Medium"],
    deploymentComplexity: "",
    deploymentComplexities: ["High", "Low", "Medium"],
    technologicalFootprint: "",
    technologicalFootprints: ["High", "Low", "Medium"],
    businessEnabler: "",
    businessEnablers: ["Yes", "No"],
    fundingStatus: "",
    fundingStatusArray: values.fundingStatusArray,
    financialStatus: "",
    opCo: "",
    newOpco: "",
    selectedAllMarkets: false,
    market: [],
    newMarket: "",
    financialStatusArray: ["High", "Low", "Medium", "Not available"],
    opCoArray: [],
    opcos: [],
    marketArray: [],
    sustainabilityGoals: [],
    sustainabilityGoalsItems: values.sustainabilityGoalsItems,
    forceRecomputeCounter: 0,
    opportunities: "",
    bslContact: "",
    projectState: "",
    linkPeers: "",
    Task_Resource: "",
    date: new Date().toISOString().substr(0, 7),
    menu: false,
    agreement: "",
    dialogDeleteConfirm: false,
    dialogDeleteConfirmMarket: false,
    opcoToDelete: {},
    enableNewOpco: false,
    marketToDelete: {},
    enableNewMarket: false,
    battlecard: "",
    battlecards: ["Yes", "No"],
    NTTLeadOpco: "",
    LeadOpco_values: values.LeadOpco_values,
    notesComments: "",
    dateAdded: new Date().toISOString().substr(0, 7),
    menuDateAdded: false,
    agreements: values.agreements,
    startup: {},
    scoreMap: {
      "Replication complexity": {
        "High": 2,
        "Low": 0,
        "Medium": 1,
        "-": 0,
        "": 0,
      },
      "Deployment complexity": {
        "High": 0,
        "Low": 2,
        "Medium": 1,
        "": 0,
        "-": 0
      },
      "Technological footprint": {
        "High": 2,
        "Low": 0,
        "Medium": 1,
        "": 0,
        "-": 0
      },
      "Extensive business enabler": {
        "y": 1,
        "n": 0,
        "": 0,
        "-": 0
      },
      "Funding status (CrunchBase)": {
        "Convertible note": 1,
        "Corporate round": 1,
        "Early stage venture": 2,
        "Grant": 1,
        "IPO": 7,
        "N/A": 0,
        "Non-equity Assistance": 1,
        "Not Available": 0,
        "Seed": 1,
        "Series A": 2,
        "Series B": 3,
        "Series C": 4,
        "Series D": 5,
        "Series E": 6,
        "Venture - Series Unknown": 2,
        "": 0,
        "-": 0,
        "Not available": 0,
        "Own funding": 0.5
      },
      "Financial status (Startuplus, iCRIBIS)": {
        "High": 2,
        "Low": 0,
        "Medium": 1,
        "-": 0,
        "": 0,
        "Not available": 0
      },
    },
  }),
  created() {
    this.getOpcos()
    this.getMarkets()
    this.getNTT_E_G_M()
    if (this.market===this.marketArray) this.selectedAllMarkets = true
    //if(this.userInfo.role === "ADMIN" || this.userInfo.role === "APPROVER_INNOVATION") this.getTrendList()

    if (this.startupId !== "" && this.startupId !== "newStartup") {
      this.getStartup(this.startupId);
    } else {
      this.token = nanoid(8);
    }
  },
  computed: {
    ...mapGetters("UserState", {
          userInfo: "getUserInfo",
        }
    ),

    opcoErrors() {
      const errors = [];

      this.forceRecomputeCounter;
      if (!this.checkValidItemBoolean(this.opCo, this.opCoArray)) {
        let error = "Value " + this.checkValidItem(this.opCo, this.opCoArray) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.opCo = this.checkValidItem(this.opCo, this.opCoArray)
      }

      return errors;
    },
    stateOfContactErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.stateOfContact, this.stateOfContacts)) {
        let error = "Value " + this.checkValidItem(this.stateOfContact, this.stateOfContacts) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.stateOfContact = this.checkValidItem(this.stateOfContact, this.stateOfContacts)
      }

      return errors;
    },
    marketErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.market, this.marketArray)) {
        let error = "Value " + this.checkValidItem(this.market, this.marketArray) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.market = this.checkValidItem(this.market, this.marketArray)
      }

      return errors;
    },
    techAreaErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.techArea, this.techAreas)) {
        let error = "Value " + this.checkValidItem(this.techArea, this.techAreas) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.techArea = this.checkValidItem(this.techArea, this.techAreas)
      }

      return errors;
    },
    NTT_E_G_M_Errors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.NTT_E_G_M, this.NTT_E_G_M_values)) {
        let error = "Value " + this.checkValidItem(this.NTT_E_G_M, this.NTT_E_G_M_values) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.NTT_E_G_M = this.checkValidItem(this.NTT_E_G_M, this.NTT_E_G_M_values)
      }

      return errors;
    },
    // RegionZone_Errors() {
    //   const errors = [];
    //   if (!this.checkValidItemBoolean(this.RegionZone, this.RegionZone_values)) {
    //     let error = "Value " + this.checkValidItem(this.RegionZone, this.RegionZone_values) + " saved in DB is not valid!"
    //     errors.push(error)
    //   } else {
    //     this.RegionZone = this.checkValidItem(this.RegionZone, this.RegionZone_values)
    //   }

    //   return errors;
    // },
    Source_Errors(){
      const errors = [];
      if (!this.checkValidItemBoolean(this.Source, this.Source_values)) {
        let error = "Value " + this.checkValidItem(this.Source, this.Source_values) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.Source = this.checkValidItem(this.Source, this.Source_values)
      }

      return errors;
    },
    replicationErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.replicationComplexity, this.replicationComplexities)) {
        let error = "Value " + this.checkValidItem(this.replicationComplexity, this.replicationComplexities) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.replicationComplexity = this.checkValidItem(this.replicationComplexity, this.replicationComplexities)
      }

      return errors;
    },
    footprintErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.technologicalFootprint, this.technologicalFootprints)) {
        let error = "Value " + this.checkValidItem(this.technologicalFootprint, this.technologicalFootprints) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.technologicalFootprint = this.checkValidItem(this.technologicalFootprint, this.technologicalFootprints)
      }

      return errors;
    },
    businessErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.businessEnabler, this.businessEnablers)) {
        let error = "Value " + this.checkValidItem(this.businessEnabler, this.businessEnablers) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.businessEnabler = this.checkValidItem(this.businessEnabler, this.businessEnablers)
      }

      return errors;
    },
    fundingErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.fundingStatus, this.fundingStatusArray)) {
        let error = "Value " + this.checkValidItem(this.fundingStatus, this.fundingStatusArray) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.fundingStatus = this.checkValidItem(this.fundingStatus, this.fundingStatusArray)
      }

      return errors;
    },
    deploymentErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.deploymentComplexity, this.deploymentComplexities)) {
        let error = "Value " + this.checkValidItem(this.deploymentComplexity, this.deploymentComplexities) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.deploymentComplexity = this.checkValidItem(this.deploymentComplexity, this.deploymentComplexities)
      }

      return errors;
    },
    financialErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.financialStatus, this.financialStatusArray)) {
        let error = "Value " + this.checkValidItem(this.financialStatus, this.financialStatusArray) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.financialStatus = this.checkValidItem(this.financialStatus, this.financialStatusArray)
      }

      return errors;
    },
    battlecardErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.battlecard, this.battlecards)) {
        let error = "Value " + this.checkValidItem(this.battlecard, this.battlecards) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.battlecard = this.checkValidItem(this.battlecard, this.battlecards)
      }

      return errors;
    },
    agreementErrors() {
      const errors = [];
      if (!this.checkValidItemBoolean(this.agreement, this.agreements)) {
        let error = "Value " + this.checkValidItem(this.agreement, this.agreements) + " saved in DB is not valid!"
        errors.push(error)
      } else {
        this.agreement = this.checkValidItem(this.agreement, this.agreements)
      }

      return errors;
    },
    startupComputed() {
      let startup = {
        "State of contact": this.stateOfContact,
        "Addressed MU": this.market,
        "Technology area": this.techArea,
        "Replication complexity": this.replicationComplexity,
        "Deployment complexity": this.deploymentComplexity,
        "Technological footprint": this.technologicalFootprint,
        "Extensive business enabler": this.convertParameter(this.businessEnabler),
        "Funding status (CrunchBase)": this.fundingStatus,
        "Financial status (Startuplus, iCRIBIS)": this.financialStatus,
        "Opportunities": this.opportunities,
        "BSL/MU contact": this.bslContact,
        "Project state (if any)": this.projectState,
        "Link to folder in Peers": this.linkPeers,
        "Evaluation date": this.date,
        "Battlecard available": this.convertParameter(this.battlecard),
        "Agreement": this.agreement,
        "OpCo": this.opCo,
        "SustainabilityGoals": this.sustainabilityGoals,
        "NTT E/G/M": this.NTT_E_G_M,
        "token": this.token,
        //"Trend": this.selectedTrend,
        "RegionZone": this.RegionZone,
        "Source" : this.Source,
        "NTT Lead Opco": this.NTTLeadOpco,
        "Date Added": this.dateAdded,
        "Notes/Comments": this.notesComments
      };
      return startup;
    }
  },
  watch: {
    NTT_E_G_M(newVal) {
      // Watch for changes in NTT_E_G_M and update TechTrend accordingly
      let requestUrl = {
        url: UrlsService.getTechTrendbyCategorybyName,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
          Name: newVal,
      }
      let requestObject = {
        type: "public",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List get Category TechTrend",
        error: "Error getting Category TechTrend",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let maxYear = Math.max(...Object.keys(responseSuccess));
            this.TechTrend = responseSuccess[maxYear];
            let techTrendData = Object.keys(responseSuccess).reduce((obj, year) => {
              obj[year] = responseSuccess[year];
              return obj;
            }, {});

            this.$refs.techGraphic.passData(techTrendData);
          });
    },
    startupComputed(newStartup) {
      let score = 0;
      for (let key in this.scoreMap) {
        if (newStartup[key] !== undefined) {
          score = score + this.scoreMap[key][newStartup[key]];
        }

      }
      this.$emit('update', score)
      return score;
    }
  },
  methods: {
    saveDateAdded() {
      this.menuDateAdded = false;
      console.log(this.dateAdded);
    },

    handleButtonClick() {
      // Add button's functionality here
      console.log("Button clicked!");
    },

    /*getTrendList() {

      let requestUrl = {
        url: UrlsService.getTrends,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {};
      let requestObject = {
        type: "radar",
        urlsInfo: requestUrl,
        data: {
          method: "get",
          data: requestData
        },
      };
      let messages = {
        title: "Get Trend List",
        loading: "Creating",
        error: "Trends Not Found",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };

      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(response => {
            response.trends.forEach(x => this.loadedTrends.push(x.title))
          })
          .catch(error => {
            console.log(error)
          })
    },*/
    deleteOpco() {
      this.dialogDeleteConfirm = false;
      let requestUrl = {
        url: UrlsService.opco,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "DELETE",
          opcoRequest: {
            value: this.opcoToDelete
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Delete opco",
        error: "Error delete opco...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.enableNewOpco = false;
            this.opCoArray = []
            this.getOpcos();
          });

    },
    deleteMarket() {
      this.dialogDeleteConfirmMarket = false;
      let requestUrl = {
        url: UrlsService.market,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "DELETE",
          marketRequest: {
            value: this.marketToDelete
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Delete market",
        error: "Error delete market...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.enableNewMarket = false;
            this.marketArray = []
            this.getMarkets();
          });

    },
    addOpco() {
      let requestUrl = {
        url: UrlsService.opco,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "CREATE",
          opcoRequest: {
            value: this.newOpco
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Create new opco",
        error: "Error create opco...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.enableNewOpco = false;
            this.newOpco = "";
            if (responseSuccess.response !== undefined && responseSuccess.response.data.responseStatus.code === 501) {
              this.opcoError = true;
              this.opcoErrorDescription = responseSuccess.response.data.responseStatus.description
            } else {
              this.getOpcos();
            }

          });

    },
    addMarket() {
      let requestUrl = {
        url: UrlsService.market,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "CREATE",
          marketRequest: {
            value: this.newMarket
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Create new market",
        error: "Error create market...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.enableNewMarket = false;
            this.newMarket = "";
            if (responseSuccess.response !== undefined && responseSuccess.response.data.responseStatus.code === 501) {
              this.marketError = true;
              this.marketErrorDescription = responseSuccess.response.data.responseStatus.description
            } else {
              this.getMarkets();
            }

          });

    },
    closeNewOpco() {
      this.enableNewOpco = false;
      this.newOpco = "";
    },
    closeNewMarket() {
      this.enableNewMarket = false;
      this.newMarket = "";
    },
    openDeleteOpco(item) {
      this.dialogDeleteConfirm = true;
      this.opcoToDelete = item;
    },
    openDeleteMarket(item) {
      this.dialogDeleteConfirmMarket = true;
      this.marketToDelete = item;
    },
    checkValidItemBoolean(item, items) {
      for (let i = 0; i < items.length; i++) {
        if (item === undefined || item === "" || item === "-") return true;
        if (item.toLowerCase() === items[i].toLowerCase()) {
          item = items[i];
          return true;
        }
      }
      return false;
    },
    checkValidItem(item, items) {
      for (let i = 0; i < items.length; i++) {
        if (item.toLowerCase() === items[i].toLowerCase()) {
          item = items[i];
          break;
        }
      }
      return item;
    },

    sanitize(event, variableName) {
      event.preventDefault();
      this[variableName] = this.$sanitize(event.target.value)
    },
    getStartup(id) {
      let startup = {
        _id: id
      }

      let requestUrl = {
        url: UrlsService.getStartupById,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          startupRequest: {
            startup: startup
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Get Startup",
        loading: "Waiting for the startup information...",
        error: "Cannot get the startup...",
      };

      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let responseStartup = responseSuccess.response.startups[0];
            this.startup = responseStartup;

            //if(this.startup["Evaluation date"] !== undefined && this.startup["Evaluation date"] !== "None"){
            //let date = new Date (this.startup["Evaluation date"]);
            //this.startup["Evaluation date"] = date.getUTCFullYear() + "-" + (date.getUTCMonth() + 1);
            //}

            for (let key in this.startup) {
              if (this.startup[key] === 'None') {
                this.startup[key] = "";
              }
            }

            this.NTTLeadOpco = this.startup["NTT Lead Opco"] === undefined ? "" : this.startup["NTT Lead Opco"];
            this.dateAdded = (this.startup["Date Added"] === undefined || this.startup["Date Added"] === '') ? this.dateAdded : this.startup["Date Added"];
            this.notesComments = this.startup["Notes/Comments"] === undefined ? "" : this.startup["Notes/Comments"];
            this.stateOfContact = this.startup["State of contact"] === undefined ? "" : this.startup["State of contact"];
            this.market = this.startup["Addressed MU"] === undefined ? "" : this.startup["Addressed MU"];
            this.techArea = this.startup["Technology area"] === undefined ? "" : this.startup["Technology area"];
            this.replicationComplexity = this.startup["Replication complexity"] === undefined ? "" : this.startup["Replication complexity"];
            this.deploymentComplexity = this.startup["Deployment complexity"] === undefined ? "" : this.startup["Deployment complexity"];
            this.technologicalFootprint = this.startup["Technological footprint"] === undefined ? "" : this.startup["Technological footprint"];
            this.businessEnabler = this.startup["Extensive business enabler"] === undefined ? "" : this.inverseConvertParameter(this.startup["Extensive business enabler"]);
            this.fundingStatus = this.startup["Funding status (CrunchBase)"] === undefined ? "" : this.startup["Funding status (CrunchBase)"];
            this.financialStatus = this.startup["Financial status (Startuplus, iCRIBIS)"] === undefined ? "" : this.startup["Financial status (Startuplus, iCRIBIS)"];
            this.opportunities =  this.startup["Opportunities"] === undefined ? "" : this.startup["Opportunities"];
            this.bslContact = this.startup["BSL/MU contact"] === undefined ? "" : this.startup["BSL/MU contact"];
            this.projectState = this.startup["Project state (if any)"] === undefined ? "" : this.startup["Project state (if any)"];
            this.linkPeers = this.startup["Link to folder in Peers"] === undefined ? "" : this.startup["Link to folder in Peers"];
            this.date = (this.startup["Evaluation date"] === undefined || this.startup["Evaluation date"] === '') ? this.date : this.startup["Evaluation date"];
            this.battlecard = this.startup["Battlecard available"] === undefined ? "" : this.inverseConvertParameter(this.startup["Battlecard available"]);
            this.agreement = this.startup["Agreement"] === undefined ? "" : this.startup["Agreement"];
            this.opCo = this.startup["OpCo"] === undefined ? "" : this.startup['OpCo'];
            this.sustainabilityGoals = this.startup["SustainabilityGoals"] === undefined ? [] : this.startup["SustainabilityGoals"];
            this.NTT_E_G_M = this.startup["NTT E/G/M"] === undefined ? "" : this.startup["NTT E/G/M"];
            this.RegionZone = this.startup["RegionZone"] === undefined ? "" : this.startup["RegionZone"];
            this.Source = this.startup["Source"] === undefined ? "" : this.startup["Source"];
            this.token = (this.startup["token"] === undefined || this.startup["token"] === "") ? nanoid(8) : this.startup["token"];
            //this.selectedTrend = this.startup["Trend"] === undefined ? "" : this.startup["Trend"];
          });
    },
    convertParameter(param) {
      if (param === "Yes") return "y";
      else if (param === "No") return "n";
      else return "-";
    },
    inverseConvertParameter(param) {
      if (param === "y") return "Yes";
      else if (param === "n") return "No";
      else return "";
    },
    formValidate() {
      this.$v.$touch();
      return this.$refs.form.validate();
    },
    clear() {
      this.$v.$reset();
      this.market = [];
      this.stateOfContact = "";
      this.techArea = "";
      this.replicationComplexity = "";
      this.deploymentComplexity = "";
      this.technologicalFootprint = "";
      this.businessEnabler = "";
      this.fundingStatus = "";
      this.financialStatus = "";
      this.opportunities = "";
      this.bslContact = "";
      this.projectState = "";
      this.linkPeers = "";
      this.Task_Resource = "";
      this.date = new Date().toISOString().substr(0, 7);
      this.agreement = "";
      this.opCo = "";
      this.sustainabilityGoals = [];
      this.NTT_E_G_M = "";
      this.battlecard = "";
      //this.selectedTrend = "";
      this.RegionZone = "";
      this.Source = "";
    },
    returnFields() {
      let startup = {
        "State of contact": this.stateOfContact,
        "Addressed MU": this.market,
        "Technology area": this.techArea,
        "Replication complexity": this.replicationComplexity,
        "Deployment complexity": this.deploymentComplexity,
        "Technological footprint": this.technologicalFootprint,
        "Extensive business enabler": this.convertParameter(this.businessEnabler),
        "Funding status (CrunchBase)": this.fundingStatus,
        "Financial status (Startuplus, iCRIBIS)": this.financialStatus,
        "Opportunities": this.opportunities,
        "BSL/MU contact": this.bslContact,
        "Project state (if any)": this.projectState,
        "Link to folder in Peers": (!this.linkPeers.startsWith("http") && this.linkPeers !== "") ? "http://" + this.linkPeers : this.linkPeers,
        "Evaluation date": this.date,
        "Battlecard available": this.convertParameter(this.battlecard),
        "OpCo": this.opCo,
        "Agreement": this.agreement,
        "SustainabilityGoals": this.sustainabilityGoals,
        "NTT E/G/M": this.NTT_E_G_M,
        "RegionZone": this.RegionZone,
        "Source": this.Source,
        "token": this.token,
        //"Trend": this.selectedTrend,
        "NTT Lead Opco": this.NTTLeadOpco,
        "Date Added": this.dateAdded,
        "Notes/Comments": this.notesComments
      };
      return startup;
    },
    getOpcos() {
      let requestUrl = {
        url: UrlsService.getTagsSuggestion,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "",
          elasticSearchRequest: {
            pageSize: 1000,
            pageNumber: 0
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List get OpCos ",
        error: "Error get OpCos...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {

            let responseOpco = responseSuccess.response.opcos;
            if (responseOpco !== undefined) {
              for (let i = 0; i < responseOpco.length; i++) {
                this.opCoArray.push(responseOpco[i].value);
              }
              this.forceRecomputeCounter++;
            }

          });
    },
    getMarkets() {
      let requestUrl = {
        url: UrlsService.getTagsSuggestion,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "",
          elasticSearchRequest: {
            pageSize: 1000,
            pageNumber: 0
          }
        },
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List get Markets ",
        error: "Error get Markets...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {

            let responseMarket = responseSuccess.response.markets;
            if (responseMarket !== undefined) {
              for (let i = 0; i < responseMarket.length; i++) {
                this.marketArray.push(responseMarket[i].value);
              }
              this.forceRecomputeCounter++;
            }

          });
    },

    getNTT_E_G_M(){
      let requestUrl = {
        url: UrlsService.getTechTrendNames,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
          // Name: "Cloud",
          // Year: "2024"
      }
      let requestObject = {
        type: "public",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List get TechTrends ",
        error: "Error getting TechTrend",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };

      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            if (responseSuccess !== undefined) {
              for (let i = 0; i < responseSuccess.length; i++) {
                this.NTT_E_G_M_values.push(responseSuccess[i]);
              }
            }
          });
    },

    selectAllMarket() {
      if (this.market===this.marketArray) {
        this.market = [];
        this.selectedAllMarkets = false;
      } else {
        this.market = this.marketArray;
        this.selectedAllMarkets = true;
      }
    },

  },
};
</script>

<style lang="scss">
</style>
